import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { PerencanaanTable } from 'app/KinerjaGpkPage/components/PerencanaanTable'
import { useApiGetPerencanaanList } from 'api/kinerja/gpk/perencanaan'

import type { KinerjaStatusGpk } from 'types/kinerja-gpk'

const DISPLAYED_STATES: Array<KinerjaStatusGpk> = ['DRAFT', 'NOT_FOUND']

export function UnsubmittedPerencanaan() {
  // -----------------------------------------
  // Get perencanaan list data
  // -----------------------------------------
  const { data: perencanaanListData, isFetching } = useApiGetPerencanaanList({
    params: {
      // To improve data fetching efficiency, we'll fetch all states at once and use it in other pages.
      // Filtering will be handled client-side.
      states: ['ALL'],
    },
    options: {
      staleTime: 60 * 60 * 1000, // 1 hour
      useErrorBoundary: true,
    },
  })

  const perencanaanItems =
    perencanaanListData?.data?.map((item) => ({
      id: item.id,
      name: item.nama,
      status: item.state,
      ptkId: item.ptkId,
    })) ?? []

  return (
    <main className="w-full max-w-7xl mx-auto py-8 px-6 min-h-screen">
      <Header title="Daftar Perencanaan Kinerja" className="mb-10" />

      <section className="shadow-card rounded-lg bg-white border border-disabled">
        <div className="px-8 pt-6 pb-5">
          <Text variant="heading-lg" as="h3" className="mb-2">
            Kabari Guru Pendidikan Khusus untuk segera mengajukan Perencanaan
          </Text>
        </div>

        <PerencanaanTable
          items={perencanaanItems}
          statusFilter={DISPLAYED_STATES}
          isLoading={isFetching}
        />
      </section>
    </main>
  )
}
